import { View } from 'react-native';
export const BlurView = View;
